import { ErrorId } from '@sheerid/jslib/src/lib/types/types';
import { getRefByFieldId } from '@sheerid/jslib';

export const getEmailConfirmationValidationError = (value: string): ErrorId => {
    const invalidEmail: ErrorId = 'invalidEmail';

    if (!value || !isValidEmailConfirmation(value)) {
        return invalidEmail;
    }
    return;
};

const isValidEmailConfirmation = (value: string): boolean => {
    const emailFieldValue: string = (getRefByFieldId('email') as HTMLInputElement).value;
    return value === emailFieldValue;
};
